<script lang="ts">
  import MenuSearchIcon from "$lib/icons/MenuSearchIcon.svelte";
  import {locale, translate} from "$lib/i18n";
  import NotificationsIcon from "$lib/icons/NotificationsIcon.svelte";
  import CasinoIcon from "$lib/icons/CasinoIcon.svelte";
  import SportsIcon from "$lib/icons/SportsIcon.svelte";
  import {mobileSidebarIsOpenStore} from "$lib/stores";
  import {page} from "$app/stores";
  import CloseIcon from "$lib/icons/CloseIcon.svelte";
  import TournamentsIcon from "$lib/icons/TournamentsIcon.svelte";
  import {openDialog} from "$lib/stores/dialogStores";

  interface Props {
    gameMode?: boolean;
  }

  let { gameMode = false }: Props = $props();
  let showNavbarWhenGameMode: boolean = $state(false);

  const toggleSideBar = () => {
    mobileSidebarIsOpenStore.update(value => !value);
  }
</script>

{#if !gameMode || showNavbarWhenGameMode}
  <div class="fixed md:hidden bottom-0 h-[68px] w-full bg-primary-dark rounded-t-3xl shadow-[0px_0px_44px_0px_rgba(0,0,0,0.75)]">
    <div class="flex justify-around items-center h-full px-4 text-white text-sm">
      <button class="flex flex-col items-center gap-1" onclick={() => toggleSideBar()}>
        <MenuSearchIcon />
        <span>{$translate('More')}</span>
      </button>
      <a href="/{$locale}/casino" class:active-tab={$page.url.pathname.includes('/casino')} class="flex-col flex items-center gap-1">
        <CasinoIcon />
        <span>{$translate('Casino')}</span>
      </a>
      <a href="/{$locale}/sports" class:active-tab={$page.url.pathname.includes('/sports')} class="flex-col flex items-center gap-1">
        <SportsIcon />
        <span>{$translate('Sports')}</span>
      </a>
      <button onclick={() => openDialog('TournamentsModal')} class="flex-col flex items-center gap-1">
        <TournamentsIcon />
        <span>{$translate('Tournament')}</span>
      </button>
    </div>
  </div>
{/if}
{#if gameMode}
  <button class="fixed md:hidden right-0 bottom-32 bg-primary-yellow rounded-l-xl p-2 transition-all duration-500" onclick={() => showNavbarWhenGameMode = !showNavbarWhenGameMode}>
    {#if showNavbarWhenGameMode}
      <CloseIcon />
    {:else}
      <MenuSearchIcon css="" />
    {/if}
  </button>
{/if}

<style lang="scss">
  .active-tab {
    position: relative;
  }
  .active-tab::after {
    background: linear-gradient(101deg, #ed1d4900, #ff1e00 48.44%, #ed1d4900);
    border-radius: 50px 50px 0 0;
    bottom: -9px;
    content: "";
    height: 3px;
    left: 50%;
    position: absolute;
    transform: translate(-50%);
    width: 36px;
  }

  .active-tab::before {
    background: #ff1e00;
    bottom: -25px;
    content: "";
    display: block;
    filter: blur(9.5px);
    height: 36px;
    left: 50%;
    opacity: .5 !important;
    position: absolute;
    transform: translate(-50%) matrix(0, -1, -1, 0, 0, 0);
    width: 10px;
  }

</style>
